<mat-dialog-content>
  <div [innerHtml]="html">Hämtar rapporten...</div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" matDialogClose>Stäng</button>
</mat-dialog-actions>